import PillBadge from "src/components/blocks/PillBadge.js";

/**
 * The "Free" corner badge shown on a non-Stanza+ calendar poster. Positioned
 * top-right by default; callers pass `sx` to reposition and `testId` to tag it.
 *
 * @param {{ sx?: object, testId?: string }} props
 */
const FreeBadge = ({ sx, testId }) => (
  <PillBadge
    label="Free"
    icon="celebration"
    testId={testId}
    sx={{
      position: "absolute",
      top: 6,
      right: 6,
      backgroundColor: "rgba(255,255,255,0.92)",
      ...sx,
    }}
  />
);

export default FreeBadge;
